import EmptyStateAction from '../../molecules/EmptyState/EmptyStateAction';
import { emptyStateActionVariant } from '../../molecules/EmptyState/emptyStateActionVariant';
import type { IEmptyStateAction } from '../DataTable.types';

export interface IDataTableEmptyActionsProps {
    actions: readonly IEmptyStateAction[];
    /** data-testid кнопок */
    actionTestId: string;
}

/** Кнопки под текстом пустого состояния таблицы: малые, рядом по центру; вид и поведение — как у `EmptyState`. */
const DataTableEmptyActions = ({ actions, actionTestId }: IDataTableEmptyActionsProps) => (
    <div className="dtb__empty-actions" data-testid="dtb-empty-actions">
        {actions.map((action, index) => (
            <EmptyStateAction
                key={`${index}-${action.label}`}
                action={action}
                variant={emptyStateActionVariant(action, index)}
                data-testid={actionTestId}
            />
        ))}
    </div>
);

export default DataTableEmptyActions;
